quoteModule.factory('rateQuotePersistService', ['$http','AppSettings','commonRESTCallService', 'erateSessionVarsService',
    'imSessionVarsService','$q', 'rateQuoteCoordService','rateQuoteScenariosService',
    'quoteSaveRequestMapper','$window','contractInfoService',
    'quoteContractArchivalService','commonTLCService', 'quoteCreationEvents', '$rootScope',
    'usageEventsService',
function ($http, appSettings, commonRESTCallService, erateSessionVarsSvc,
              imSessionVarsService,$q, rateQuoteCoordService, rateQuoteScenariosService,
              quoteSaveRequestMapper, $window, contractInfoService,
              quoteContractArchivalService,commonTLCService, quoteCreationEvents, $rootScope, usageEventsService) {
        var rateQuotePersistService = {};

        rateQuotePersistService.encryptedQuoteIDs = {};

        //-----------------------------------------
        //-----------------------------------------
        //var _saveInProgress = false;

        var getSaveInProgress = function(){
            var val = $window.sessionStorage.getItem('SPAN_SAVE_IN_PROGRESS');
            if (!val)
                return false;
            else
                return val == "true";
        }

        var setSaveInProgress = function(val){
            $window.sessionStorage.setItem('SPAN_SAVE_IN_PROGRESS',val);
        }

        rateQuotePersistService.getSaveInProgress = function() {
            return getSaveInProgress();
        }

        rateQuotePersistService.startNewQuote = function(){
            setSaveInProgress(false);
            rateQuotePersistService.encryptedQuoteIDs = {};
        }

        rateQuotePersistService.getEncryptedQuoteId = function(quoteNum){
            return rateQuotePersistService.encryptedQuoteIDs['' + quoteNum];
        }

        rateQuotePersistService.setEncryptedQuoteId = function(quoteNum, encryptedId){
            rateQuotePersistService.encryptedQuoteIDs['' + quoteNum] = encryptedId;
        }
        //determine if rates are OK to save
        rateQuotePersistService.readyToSaveQuotes = function () {
            //must have at a minimum vehicle data. Used to also require customer data, however this causes an issue
            // because if you can't save a quote without customer data, then you can't contract/go to preflight.
            // But preflight is supposed to tell you if you're missing the customer data! Catch-22
            var okSoFar =
                rateQuoteCoordService.VehicleData != null && rateQuoteCoordService.VehicleData.dataReadyToSaveQuote() &&
                !getSaveInProgress();
            //must have at least one rate selected
            if (rateQuoteScenariosService.getScenarioList() && rateQuoteScenariosService.getScenarioList().length > 0) {
                rateQuoteScenariosService.getScenarioList().forEach(function (scen) {
                    if (!(rateQuoteCoordService.getHeldQuotesPerProposal()[scen] && rateQuoteCoordService.getHeldQuotesPerProposal()[scen].length > 0)) {
                        okSoFar = false;
                    }
                });
            }else {okSoFar = false;}

            if (okSoFar)
                setSaveInProgress(true);

            return okSoFar;
        }

        //save quote request template (grab from url)
        rateQuotePersistService.getQuoteSaveRequestTemplate = function () {
            var deferred = $q.defer();
            deferred.resolve({"CachedProductResponseIds":null,"CachedRateResponseIds":null,"Rates":[{"CreatedBy":0,"CreatedDate":"\/Date(1454015136908)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1454015136908)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"AlternateFinancingMode":0,"BaseNoUpgradeProductRates":null,"RatedCoverage":null,"RatedDeductible":null,"RatedProduct":null,"RatedTerms":null,"RatedVehicleClass":null}],"applicationPartnerCode":"","customerInformation":{"BusinessName":null,"BuyerEmail":null,"BuyerFirstName":null,"BuyerLastName":null,"BuyerMiddleName":null,"City":null,"CoBuyerEmail":null,"CoBuyerFirstName":null,"CoBuyerLastName":null,"CoBuyerMiddleName":null,"CustomerAddressLine1":null,"CustomerAddressLine2":null,"CustomerPhone1":null,"CustomerPhone2":null,"DriverFirstName":null,"DriverLastName":null,"State":null,"Zip":null},"dateOfSale":"1\/28\/2016","dealershipAccountCode":"","partnerSpecificFields":[{"key":"","value":""}],"quoteScenarioId":"","quoteSessionId":"","vehicleCertification":null,"vehicleFinancials":{"AmountFinanced":0,"DMSDealNumber":null,"DaysToFirstPayment":0,"FinancedAPR":0,"FinancedTermMonths":0,"FirstPaymentDate":null,"LenderAddress1":null,"LenderAddress2":null,"LenderCity":null,"LenderCode":null,"LenderEmail":null,"LenderName":null,"LenderPhone":null,"LenderState":null,"LenderZip":null,"MSRP":0,"MoneyFactor":0,"PurchasePrice":0,"StockNumber":null,"VehicleSaleType":null},"vehicleInservice":"1\/28\/2016","vehicleOdometer":0,"vehicleToRate":{"CreatedBy":0,"CreatedDate":"\/Date(1454015136908)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1454015136908)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"InternalVINId":null,"Make":{"CreatedBy":0,"CreatedDate":"\/Date(1454015136908)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1454015136908)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"InternalMakeId":null,"MakeAbbreviation":null,"MakeName":null,"PartnerMakeCode":null},"Model":{"CreatedBy":0,"CreatedDate":"\/Date(1454015136908)\/","ID":-2147483648,"LastModifiedDate":"\/Date(1454015136908)\/","ModifiedBy":-2147483648,"PartnerSpecificFields":{"FlexFields":[]},"BaseName":null,"CylindersCount":0,"DriveWheelsOption":0,"DutyWeightOption":0,"FuelOption":0,"InternalModelId":null,"ModelYear":0,"PartnerModelCode":null,"PartnerModelName":null,"PerformanceOption":0,"SeriesName":null},"ModelYear":0,"OriginalVehicleIdentification":null,"VehicleIdentificationPattern":null},"vehicleUsageTypes":null});
            return deferred.promise;
        }

        //(public) save rates, vehicle, customer, deal data as quote(s)
        rateQuotePersistService.saveRatesAsQuotes = function () {
            setSaveInProgress(true);

            var deferred = $q.defer();

            var providerData = angular.merge({}, rateQuoteCoordService.getCapturedProviderData(), contractInfoService.contractProductInfo);
            var customerData = rateQuoteCoordService.CustomerData,
                vehicleData = rateQuoteCoordService.VehicleData,
                dealData = rateQuoteCoordService.DealData,
                lenderData = rateQuoteCoordService.LenderData.selectedLender,
                partnerSpecificFields = convertToKeyValuePairs(providerData);

            privateSaveRatesAsQuotes(customerData, vehicleData, dealData, lenderData, partnerSpecificFields, function (err, success) {
                setSaveInProgress(false);
                $rootScope.$broadcast(quoteCreationEvents.customerDataRetrieved,
                    {});
                if (err) {
                    deferred.reject(err);
                }
                deferred.resolve(rateQuoteCoordService.getHeldQuotesPerProposal());
            });

            return deferred.promise;
        }

        // Given an object, return it as an array of key/value pairs
        var convertToKeyValuePairs = function(item) {
            if (!item) {
                return [];
            }

            var fieldsArray = [];
            for(var property in item) {
                if(item.hasOwnProperty(property)) {

                    var propValue = item[property];
                    if(angular.isDate(item[property])) {
                        propValue = propValue.yyyymmdd();
                    }

                    fieldsArray.push({"key":property, "value": propValue});
                }
            }

            return fieldsArray;
        };

        //save the rates, customer, vehicle, and deal data as quotes
        var privateSaveRatesAsQuotes = function (customerData, vehicleData, dealData, lenderData, partnerSpecificFields, callback) {
            //customerData in /models/customer-info.js format
            //vehicleData in /models/vehicle-info.js format
            //dealData in /models/deal-info.js format

            rateQuoteScenariosService.getScenarioList().forEach(function saveQuotesInScenario(nxtScenario) {
                quoteSvRequest = rateQuotePersistService.getQuoteSaveRequestTemplate()
                    .then(function saveTemplateReceived(quoteSvRequest) {
                        //map quote data
                        quoteSaveRequestMapper.mapAllDataToSaveRequestObject(
                            quoteSvRequest, nxtScenario, vehicleData, dealData, customerData, lenderData, partnerSpecificFields
                        );
                        //save the data
                        var url = appSettings.startSPANRatePersistURL + "/SaveQuotesFromRates/" + imSessionVarsService.getCurrentProviderCode();
                        commonRESTCallService.postToServer(url, quoteSvRequest)
                            .success(function (data, status) {

                                var i=0;
                                data.SavedRates.forEach(function(nxtRate){
                                    rateQuoteCoordService.holdRateForQuote(nxtRate, nxtScenario, data.CachedProductResponseIds!=null ? data.CachedProductResponseIds[i] : null, data.CachedRateResponseIds !=null ? data.CachedRateResponseIds[i] : null);
                                    i = i + 1;
                                });

                                usageEventsService.quoteSaved(rateQuoteCoordService.getQuoteSessionId(), i);

                                if (!(data.EncodedQuoteNums && data.EncodedQuoteNums.length > 0)) {
                                    var encPromises = data.SavedRates.map(function (nxtRate) {
                                        return commonTLCService.encryptNumeric(nxtRate.RatedTerms[0].SavedRateUniqueId);
                                    });

                                    $q.all(encPromises)
                                        .then(function (encodedIds) {
                                            for (var i = 0; i < encodedIds.length; i++) {
                                                rateQuotePersistService.encryptedQuoteIDs['' + data.SavedRates[i].RatedTerms[0].SavedRateUniqueId] = encodedIds[i];
                                            }
                                            callback(null, true);
                                        });
                                }else{
                                    for (var i = 0; i < data.EncodedQuoteNums.length; i++) {
                                        rateQuotePersistService.setEncryptedQuoteId(data.SavedRates[i].RatedTerms[0].SavedRateUniqueId,data.EncodedQuoteNums[i]);
                                    }
                                    callback(null, true);
                                }
                            })
                            .error(function (data, status) {
                                callback(new Error(status + ' ' + data))
                            });
                    },
                    function (err) {
                        setSaveInProgress(false);
                        throw new Error(err);
                    });
            });
        }

        rateQuotePersistService.removeAllButCurrentScenario = function(isMenuIntegrated) {
            var deferred = $q.defer();

            if (isMenuIntegrated){
                //if we are menu integrated, we don't delete quotes!!
                deferred.resolve(true);
            }
            else{
                setSaveInProgress(true);

                var currentScenario = rateQuoteScenariosService.getCurrentScenario();

                var allScenarios = rateQuoteScenariosService.getScenarioList();

                var copyScenarios = angular.copy(allScenarios);

                var locCurr = copyScenarios.indexOf(currentScenario);

                //copyScenarios = copyScenarios.splice(locCurr,1);

                var proposalRemoves = copyScenarios.map(function(scen){
                    if (scen !== currentScenario)
                        return rateQuotePersistService.removeQuoteScenario(scen);
                    else
                        return null;
                });

                $q.all(proposalRemoves)
                .then(
                    function(results){
                        setSaveInProgress(false);
                        deferred.resolve(true);
                    }
                )
                .catch(
                    function(reason){
                        setSaveInProgress(false);
                        deferred.reject(reason);
                    }
                )
            }
            return deferred.promise;
        }

        //remove a quoting scenario and delete if already persisted
        rateQuotePersistService.removeQuoteScenario = function (scenarioToRemove) {
            var deferred = $q.defer();

            //prevents us from saving
            setSaveInProgress(true);

            if (!scenarioToRemove) {
                setSaveInProgress(false);
                deferred.reject("No scenario number passed.");
            }
            else if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioToRemove) < 0) {
                setSaveInProgress(false);
                deferred.reject("Invalid scenario number passed.");
            }
            else {
                var needToCallDelete = false;
                if (rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioToRemove]!=null){
                    rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioToRemove].forEach(function (nxtQuote) {
                        if (nxtQuote.RatedTerms[0].SavedRateUniqueId) {
                            needToCallDelete = true;
                        }
                    });
                }

                if (needToCallDelete) {
                    var url = appSettings.startSPANRatePersistURL + "/RemoveQuotesByScenarioId/" + imSessionVarsService.getCurrentProviderCode() +
                        "/" + rateQuoteCoordService.getQuoteSessionId() + "/" + scenarioToRemove;

                    //remove the quote
                    commonRESTCallService.deleteToServer(url)
                        .success(function (data, status) {
                            rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioToRemove] = [];
                            rateQuoteScenariosService.removeScenario(scenarioToRemove);
                            setSaveInProgress(false);
                            deferred.resolve(true);//just return completion
                        })
                        .error(function (data, status) {
                            setSaveInProgress(false);
                            deferred.reject(data);
                        });
                }
                else {
                    rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioToRemove] = [];
                    rateQuoteScenariosService.removeScenario(scenarioToRemove);
                    setSaveInProgress(false);
                    deferred.resolve(true);
                }
            }

            return deferred.promise;
        }
        //remove a specific quote on a scenario
        rateQuotePersistService.removeQuoteOnScenario = function(scenarioId,productCategoryCode){
            var deferred = $q.defer();

            setSaveInProgress(true);

            if (!scenarioId) {
                setSaveInProgress(false);
                deferred.reject("No scenario number passed.");
            }
            else if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioId) < 0) {
                setSaveInProgress(false);
                deferred.reject("Invalid scenario number passed.");
            }
            else {
                var needToCallDelete = false;
                var quoteToDel = -1;
                var i = 0;
                var quoteId = null;
                var quoteSessionNum = null;
                rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].forEach(function (nxtQuote) {
                    if (nxtQuote.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase() == productCategoryCode.toUpperCase()) {
                        quoteToDel = i;
                        if (nxtQuote.RatedTerms[0].SavedRateUniqueId) {
                            quoteId = nxtQuote.RatedTerms[0].SavedRateUniqueId;
                            quoteSessionNum = nxtQuote.RatedTerms[0].SavedRateSessionId;
                            needToCallDelete = true;
                        }
                    }
                    i = i + 1;
                });

                if (needToCallDelete){
                    commonTLCService.encryptNumeric(quoteId)
                    .then(
                    function(encryptedId) {
                        if (contractInfoService.contractsPerQuote[quoteId]) {
                            quoteContractArchivalService.archiveContractsForQuote([quoteId], [encryptedId])
                                .then(
                                function (completed) {
                                    privateRemoveQuoteById(encryptedId, deferred, scenarioId, quoteId, quoteSessionNum);
                                }
                            );
                        }
                        else {
                            privateRemoveQuoteById(encryptedId, deferred, scenarioId, quoteId, quoteSessionNum);
                        }
                    },
                    function(err){
                        throw err;
                    }
                    );
                }else if (quoteToDel >= 0) {
                    rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].splice(quoteToDel,1)
                    setSaveInProgress(false);
                    deferred.resolve(true);
                }else{
                    deferred.reject('quote category not found.');
                }
            }
            return deferred.promise;
        }

        //remove a specific quote on a scenario
        rateQuotePersistService.removeQuoteById = function(scenarioId,quoteId){
            var deferred = $q.defer();

            setSaveInProgress(true);

            if (!scenarioId) {
                setSaveInProgress(false);
                deferred.reject("No scenario number passed.");
            }
            else if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioId) < 0) {
                setSaveInProgress(false);
                deferred.reject("Invalid scenario number passed.");
            }
            else {
                var needToCallDelete = false;
                var quoteToDel = -1;
                var i = 0;
                var quoteSessionNum = null;
                rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].forEach(function (nxtQuote) {
                    if (nxtQuote.RatedTerms[0].SavedRateUniqueId && parseInt(nxtQuote.RatedTerms[0].SavedRateUniqueId) == parseInt(quoteId)) {
                        quoteToDel = i;
                        if (nxtQuote.RatedTerms[0].SavedRateUniqueId) {
                            quoteSessionNum = nxtQuote.RatedTerms[0].SavedRateSessionId;
                            needToCallDelete = true;
                        }
                    }
                    i = i + 1;
                });

                if (needToCallDelete){
                    commonTLCService.encryptNumeric(quoteId)
                        .then(
                        function(encryptedId) {
                            if (contractInfoService.contractsPerQuote[quoteId]) {
                                quoteContractArchivalService.archiveContractsForQuote([quoteId], [encryptedId])
                                    .then(
                                    function (completed) {
                                        privateRemoveQuoteById(encryptedId, deferred, scenarioId, quoteId, quoteSessionNum);
                                    }
                                );
                            }
                            else {
                                privateRemoveQuoteById(encryptedId, deferred, scenarioId, quoteId, quoteSessionNum);
                            }
                        },
                        function(err){
                            throw err;
                        }
                    );
                }else if (quoteToDel >= 0) {
                    rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].splice(quoteToDel,1)
                    setSaveInProgress(false);
                    deferred.resolve(true);
                }else{
                    deferred.reject('quote not found.');
                }
            }
            return deferred.promise;
        }

        //determine if we can remove quotes
        rateQuotePersistService.okToRemoveQuotes = function () {
            var okSoFar = !getSaveInProgress();
            if (!okSoFar){ return okSoFar; }
            rateQuoteScenariosService.getScenarioList().forEach(function (scen) {
                if (rateQuoteCoordService.getHeldQuotesPerProposal()[scen].length == 0) {
                    okSoFar = false;
                }
            });
            return okSoFar;
        }

        //
        // "removeallquotes" was never used, removed
        //

        var privateRemoveQuoteById = function(encryptedId, deferred, scenarioId, quoteId, quoteSessionNum){

           // Passing the quoteSessionNumber of the quote we are handling, not the current one
            var url = appSettings.startSPANRatePersistURL + "/RemoveQuoteById/" + imSessionVarsService.getCurrentProviderCode() +
                "/" + quoteSessionNum + "/" + encryptedId;

            //remove the quote
            commonRESTCallService.deleteToServer(url)
            .success(function (data, status) {
                var quoteToDel = -1;
                var i = 0;
                rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].forEach(function (nxtQuote) {
                    if (nxtQuote.RatedTerms[0].SavedRateUniqueId && parseInt(nxtQuote.RatedTerms[0].SavedRateUniqueId) == parseInt(quoteId)) {
                        quoteToDel = i;
                    }
                    i = i + 1;
                });
                rateQuoteCoordService.getHeldQuotesPerProposal()[scenarioId].splice(quoteToDel, 1)
                setSaveInProgress(false);
                deferred.resolve(true);//just return completion
            })
            .error(function (data, status) {
                setSaveInProgress(false);
                deferred.reject(data);
            });

        }

        return rateQuotePersistService;
    }]);
